const AssetConfig = [
  {
    handle: 'GOLD',
    enabled: true,
    showHistory: true,
    buyStandard: true,
    type: 'METAL',
    erc20: false,
    description: '',
    transfers: '',
    colors: {
      primary: '230, 189, 115',
      secondary: '255, 232, 193',
    },
    deposit: {},
  },
  {
    handle: 'SILV',
    enabled: true,
    showHistory: true,
    buyStandard: true,
    type: 'METAL',
    erc20: false,
    description: '',
    transfers: '',
    colors: {
      primary: '132, 141, 154',
      secondary: '255, 255, 255',
    },
    deposit: {},
  },
  {
    handle: 'PLAT',
    enabled: false,
    showHistory: false,
    buyStandard: false,
    type: 'METAL',
    erc20: false,
    description: '',
    transfers: '',
    colors: {
      primary: '200, 212, 230',
      secondary: '255, 255, 255',
    },
    deposit: {},
  },
  {
    handle: 'PALL',
    enabled: false,
    showHistory: false,
    buyStandard: false,
    type: 'METAL',
    erc20: false,
    description: '',
    transfers: '',
    colors: {
      primary: '230, 219, 200',
      secondary: '255, 255, 255',
    },
    deposit: {},
  },
  {
    handle: 'BTC',
    enabled: true,
    showHistory: true,
    buyStandard: true,
    type: 'CRYPTO',
    erc20: false,
    description: 'The original cryptocurrency from Satoshi Nakamoto',
    transfers: {
      regex: '.{24,90}',
      confirmations: 6,
      limitText: 'Must be between 24 and 90 characters long',
    },
    colors: {
      primary: '255, 111, 60',
      secondary: '255, 168, 111',
    },
    deposit: {
      min: 'No Min',
      fee: 'Free',
    },
  },
  {
    handle: 'USDT',
    enabled: true,
    showHistory: true,
    buyStandard: true,
    type: 'CRYPTO',
    erc20: true,
    description: 'Digital money for a digital age',
    transfers: {
      regex: '.{40,42}',
      confirmations: 1,
      limitText: 'Must be 42 characters long, including the "0x"',
    },
    colors: {
      primary: '38, 161, 123',
      secondary: '26, 128, 96',
    },
    deposit: {
      min: '35 USDT',
      fee: '5 USDT',
    },
  },
  {
    handle: 'LINK',
    enabled: true,
    showHistory: true,
    buyStandard: true,
    type: 'CRYPTO',
    erc20: true,
    description: 'Connect your smart contract to the outside world',
    transfers: {
      regex: '.{40,42}',
      confirmations: 1,
      limitText: 'Must be 42 characters long, including the "0x"',
    },
    colors: {
      primary: '0, 139, 230',
      secondary: '94, 202, 255',
    },
    deposit: {
      min: '1.5 LINK',
      fee: '0.12 LINK',
    },
  },
  {
    handle: 'USDC',
    enabled: true,
    showHistory: true,
    buyStandard: true,
    type: 'CRYPTO',
    erc20: true,
    description: 'the world\'s leading digital dollar stablecoin',
    transfers: {
      regex: '.{40,42}',
      confirmations: 1,
      limitText: 'Must be 42 characters long, including the "0x"',
    },
    colors: {
      primary: '0, 139, 230',
      secondary: '94, 202, 255',
    },
    deposit: {
      min: '35 USDC',
      fee: '5 USDC',
    },
  },
  {
    handle: 'UNI',
    enabled: true,
    showHistory: true,
    buyStandard: true,
    type: 'CRYPTO',
    erc20: true,
    description: 'Decentralized Trading Protocol',
    transfers: {
      regex: '.{40,42}',
      confirmations: 1,
      limitText: 'Must be 42 characters long, including the "0x"',
    },
    colors: {
      primary: '255, 31, 138',
      secondary: '189, 0, 255',
    },
    deposit: {
      min: '2 UNI',
      fee: '0.5 UNI',
    },
  },
  {
    handle: 'DAI',
    enabled: true,
    showHistory: true,
    buyStandard: true,
    type: 'CRYPTO',
    erc20: true,
    description: 'A better, smarter currency',
    transfers: {
      regex: '.{40,42}',
      confirmations: 1,
      limitText: 'Must be 42 characters long, including the "0x"',
    },
    colors: {
      primary: '255, 206, 69',
      secondary: '217, 165, 71',
    },
    deposit: {
      min: '35 DAI',
      fee: '5 DAI',
    },
  },
  {
    handle: 'DASH',
    enabled: false,
    showHistory: true,
    buyStandard: false,
    type: 'CRYPTO',
    erc20: false,
    description: 'Digital cash for both the internet and everyday life',
    transfers: {
      regex: '.{24,42}',
      confirmations: 2,
      limitText: 'Must be between 24 and 42 characters long',
    },
    colors: {
      primary: '94, 202, 255',
      secondary: '0, 139, 230',
    },
    deposit: {
      min: 'No Min',
      fee: 'Free',
    },
  },
  {
    handle: 'ETH',
    enabled: true,
    showHistory: true,
    buyStandard: true,
    type: 'CRYPTO',
    erc20: true,
    description: 'The world\'s programmable blockchain',
    transfers: {
      regex: '.{40,40}',
      confirmations: 1,
      limitText: 'Must be 42 characters long, including the "0x"',
    },
    colors: {
      primary: '93, 107, 191',
      secondary: '121, 134, 204',
    },
    deposit: {
      min: 'No Min',
      fee: 'Variable on-chain fee',
    },
  },
  {
    handle: 'LTC',
    enabled: true,
    showHistory: true,
    buyStandard: true,
    type: 'CRYPTO',
    erc20: false,
    description: 'Decentralised money for the internet age',
    transfers: {
      regex: '.{26,43}',
      confirmations: 6,
      limitText: 'Must be between 26 and 43 characters long',
    },
    colors: {
      primary: '62, 96, 255',
      secondary: '110, 223, 255',
    },
    deposit: {
      min: 'No Min',
      fee: 'Free',
    },
  },
  {
    handle: 'EOS',
    enabled: false,
    showHistory: false,
    buyStandard: false,
    type: 'CRYPTO',
    erc20: false,
    description: '',
    transfers: {
      regex: '',
      confirmations: '',
      limitText: '',
    },
    colors: {
      primary: '129, 103, 254',
      secondary: '222, 147, 217',
    },
    deposit: {},
  },
  {
    handle: 'TST',
    enabled: false,
    showHistory: false,
    buyStandard: false,
    type: 'CRYPTO',
    erc20: true,
    description: 'The Standard decentralized finance protocol for a stable monetary system backed by hard and soft assets.',
    transfers: {
      regex: '',
      confirmations: '',
      limitText: '',
    },
    colors: {
      primary: '111, 97, 246',
      secondary: '70, 56, 208',
    },
  },
  {
    handle: 'EUR',
    enabled: false,
    showHistory: true,
    buyStandard: false,
    type: 'FIAT',
    erc20: false,
    description: '',
    transfers: {
      regex: '',
      confirmations: '',
      limitText: '',
    },
    colors: {
      primary: '38, 161, 123',
      secondary: '26, 128, 96',
    },
  },
  {
    handle: 'VEUR',
    enabled: true,
    showHistory: true,
    buyStandard: true,
    type: 'CRYPTO',
    erc20: true,
    description: 'The Vaultoro Euro token for you to trade with Euros.',
    transfers: {
      regex: '',
      confirmations: '',
      limitText: '',
    },
    colors: {
      primary: '38, 161, 123',
      secondary: '26, 128, 96',
    },
  },
  {
    handle: 'GBP',
    enabled: false,
    showHistory: true,
    buyStandard: false,
    type: 'FIAT',
    erc20: false,
    description: '',
    transfers: {
      regex: '',
      confirmations: '',
      limitText: '',
    },
    colors: {
      primary: '38, 161, 123',
      secondary: '26, 128, 96',
    },
  },
  {
    handle: 'VGBP',
    enabled: true,
    showHistory: true,
    buyStandard: true,
    type: 'CRYPTO',
    erc20: true,
    description: 'The Vaultoro GBP token for you to trade with GBP.',
    transfers: {
      regex: '',
      confirmations: '',
      limitText: '',
    },
    colors: {
      primary: '38, 161, 123',
      secondary: '26, 128, 96',
    },
  },
];

export default AssetConfig;
